import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    NavigationMenuLayoutContextType,
    NavigationMenuItemContextType,
    NavigationMenuContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const NavigationMenuContext = createContext<NavigationMenuContextType | undefined>(undefined);

export const NavigationMenuLayoutContext = createContext<NavigationMenuLayoutContextType>({
    isSheet: false
});

export const NavigationMenuItemContext = createContext<NavigationMenuItemContextType | undefined>(undefined);

export const NavigationMenuToggleContext = createContext(false);

export const useNavigationMenuContext = ({
    part
}: {
    part: string;
}): NavigationMenuContextType | undefined => {
    const context = useContext(NavigationMenuContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `NavigationMenu.${part}: must be rendered inside <NavigationMenu>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};
